module.exports = __webpack_public_path__ + "static/media/46.4816e54a.jpg";